module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_icon01-ab25355c46d1ae538f74c3c725e7078d.png";